import { useEffect, useState } from 'react';
import { useNavigate, useLocation, Outlet } from 'react-router-dom';
import supabase from '../utils/supabaseClient';
import { trackEvent } from '../utils/analytics';

function ProtectedRoute() {
  const [checking, setChecking] = useState(true);
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    const checkAuth = async () => {
      const { data: { session } } = await supabase.auth.getSession();
      if (!session) {
        trackEvent('auth_start_page', { page: location.pathname });
        navigate(`/auth?redirect=${encodeURIComponent(location.pathname)}`);
        return;
      }
      // Check for banned role in user metadata (if you store it there)
      const user = session.user;
      const roles = user?.user_metadata?.roles || [];
      if (roles.includes('banned')) {
        navigate('/blocked');
        return;
      }
      setChecking(false);
    };
    checkAuth();
  }, [navigate, location]);

  if (checking) return null;
  return <Outlet />;
}

export default ProtectedRoute; 